const backgroundColor = 'white';
const headerHeight = '48px';
const layer0 = 0;
const layer1 = 100;
const layer2 = 500;
const layer3 = 800;
const layer4 = 999;

const primary = '#0747a6';
const primaryColor = '#0747a6';

const swimlaneHeadWidth = '100px';
const toolbarBackgroundColour = 'ghostwhite';
const toolbarBorderBottom = '3px solid #dedede';
const toolbarHeight = headerHeight;

const sidebarButtonHeight = '145px';
const sidebarButtonWidth = '32px';
const sidebarWidth = '280px';

export const JOB_STATUS_COLORS = {
  QUEUED: '#0052CC', RUNNING: '#0052CC', COMPLETED: '#0052CC', SUCCEEDED: '#00875A', FAILED: '#DE350B', CANCELLED: '#97A0AF',
};

export const SelectDefaultHeightStyles = {
  control: (provided) => ({
    ...provided, minHeight: '40px',
  })
};

export {
  backgroundColor, headerHeight, layer0, layer1, layer2, layer3, layer4, primary, primaryColor, swimlaneHeadWidth, toolbarBackgroundColour, toolbarBorderBottom, toolbarHeight, sidebarButtonHeight, sidebarButtonWidth, sidebarWidth
};
